import { Injectable } from '@angular/core';
import { IAttributes, IRace } from '../models/IAttributes';
import { IHPIDetails } from '../models/IHPIDetails';
import { Observable } from 'rxjs';
//import { Configuration } from '../Utilities/configurations';
// var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IUserDetails } from '../models/IUsersDetails';
import { ICityDetails } from '../models/ICityDetails';
import { IAmmendment, IPersonalInfo } from '../models/IPersonalInfo';
import { IPatientSearch } from '../models/IPatientSearch.model';
import { BillingClaimCodesMaster, IClaimCodeMaster, IPaymentSource, MasterPayerTypes } from '../models/IClaimCodeMaster';
import { ICptOrdersComponent } from '../models/ICptOrdersComponent';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { IInsuranceCarriers } from '../models/IInsuranceCarriers';
import { configuration } from 'src/environments/environment';
import { Defaults } from '../Utilities/defaults';
import { IAlerts } from '../models/IAlerts';
import { IMedicationMasterData } from '../models/IMedicationMasterData';
import { ILocationDetails } from '../models/ILocationDetails';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { OuterMenu } from '../Services/common.service';
import { LocationHeader } from '../models/LocationHeader';
import { IdoclibFields } from '../models/IDocumentLibrary';
import { IMessageInbox } from '../models/IMessagetype';
import { AuditLog } from '../models/iauditlog.model';
import { ONCCConfiguration, ONCCMasterMeasure, ONCCMasterMeasures } from '../models/IMasterAddedData';
import { AutoMeasureReportConfig, MeasureNumDenumaretor } from '../models/IEncounterReport';
import { PatientReferralTracker } from '../models/PatientReferralTracker';

@Injectable({ providedIn: 'root' })
export class SharedService {
  public lstattrbutes: IAttributes[];
  public lsthpiSumptoms: IHPIDetails[];
  public lstPopUpAlerts: IAlerts[];
  constructor(private http: HttpClient) {
    this.lstattrbutes;
  }
  getservercurrentdate(): Observable<string> {
    if (sessionStorage.getItem("LocationId"))
      return this.http.get<string>(`${configuration.apiUrl}Admin/ServerDate?locationId=${sessionStorage.getItem("LocationId")}`);
    else
      return null
  }
  // Get all master attributes
  getAttributes(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/Attributes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Get attributes by attribute type id
  getAttributesById(id): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/AttributesByType'}?attributeid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Get all users by role
  // getAllUsersByRole(role: string): Observable<IUserDetails[]> {
  //   return this.http.get<IUserDetails[]>(
  //     `${configuration.apiUrl + 'Admin/ByRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }
  getAllUsersByRole(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }
  // Get all users by role with out Location Id
  getAllUsersByRoleWithOutLocId(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRoleWoutLocId'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
  // Get all users by role and selected location
  getselectedlocidByrole(role: string, locationid: Number, ascFacilityId: Number = 0): Observable<IUserDetails[]> {
    const facId = ascFacilityId > 0 ? ascFacilityId : Number(sessionStorage.getItem("FacilityId"));
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRoleandlocId'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${facId}&&locationId=${locationid}`);
  }
  // Get all users by role and selected location
  getselectedmultiplelocidByrole(role: string, locationid: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRolebyMultiplelocId'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${locationid}`);
  }
  getselectedmultiplelocidByroleForScheduledReports(role: string, locationid: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRolebyMultiplelocIdForScheduledReports'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${locationid}`);
  }
  getAllUsersByCirculatorRole(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/CirculatorRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }
  // Get city and state details by zipcode
  getZipCodeDetails(zipcode: number): Observable<ICityDetails> {
    return this.http.get<ICityDetails>(
      `${configuration.apiUrl + 'Master/ZipCode'}?zipcode=${zipcode}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }


  // Get all active doctors and nurses
  getUsersbyMultipleRoles(role1: string, role2: string, role3: string, type: string): Observable<IUserDetails[]> {
    const postedDate = {
      role1: role1,
      role2: role2,
      role3: role3,
      type: type,
      active: true,
      facility: sessionStorage.getItem("FacilityId"),
      locationId: sessionStorage.getItem("LocationId")
    }
    return this.http.post<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/UsersByMultipleRoles'}`, postedDate);
  }

  // Get all Insurance Payers
  getInsCarriers(): Observable<IInsuranceCarriers[]> {
    return this.http.get<IInsuranceCarriers[]>(`${configuration.apiUrl + 'Master/ActivePayers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }


  // Get practice admin
  getPracticeManagers(userId: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/PracticeManagers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  //Get locations


  //Get serverdate


  //Get User by Id


  //Get patient by Id    
  getPatientInfo(id: number): Observable<IPatientSearch> {
    return this.http.get<IPatientSearch>(
      `${configuration.apiUrl + 'Patient/Patient'}?patientid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //Save ORType Data Service
  saveAssessmentName(assessmentTypeInfo: IAttributes): Observable<IAttributes> {
    return this.http.post<IAttributes>(`${configuration.clinicapiUrl + 'Master/AssessmentName'}?facilityId=${sessionStorage.getItem("FacilityId")}`, assessmentTypeInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  saveAddComboBoxDetails(assessmentTypeInfo: IAttributes, locationIds: string): Observable<IAttributes> {
    return this.http.post<IAttributes>(`${configuration.clinicapiUrl + 'Master/AddComboBoxData'}?facilityId=${sessionStorage.getItem("FacilityId")}&&locationIds=${locationIds}`, assessmentTypeInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //Delete ORType Master Data Service
  // DeleteMasterAssessmentName(AscId: string, datetime: string): Observable<String> {
  //   return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/MasterAssessmentName'}?AscId=${AscId}&&datetime=${datetime}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  DeleteMasterAssessmentName(AscId: string, datetime: string): Observable<String> {
    const postdata = {
      AscId: AscId,
      datetime: datetime,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/MasterAssessmentName'}?locationId=${sessionStorage.getItem("LocationId")}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get all claim codes
  getClaimCodes(): Observable<IClaimCodeMaster[]> {
    return this.http.get<IClaimCodeMaster[]>(`${configuration.apiUrl + 'Master/AllClaimCodes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Get all cpt codes
  getCPTCodes(): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(`${configuration.apiUrl + 'Master/CPTCodes'}`);
  }

  getIsSignedoff(encoounterId: string, type: number): Observable<IEncounterData> {
    return this.http.get<IEncounterData>
      (`${configuration.clinicapiUrl + 'Encounter/GetEncounterdetails'}?encounterId=${encoounterId}&&categoryId=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }
  getOrderNoteIsSignedoff(encoounterId: string, type: number): Observable<IEncounterData> {
    return this.http.get<IEncounterData>
      (`${configuration.clinicapiUrl + 'Encounter/GetordernoteIssigneddetails'}?encounterId=${encoounterId}&&categoryId=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }
  // Get auth signoff details
  getAuthSignOffStatus(encId): Observable<String> {
    return this.http.get<String>(`${configuration.clinicapiUrl + 'Encounter/CONSENTSIGNOFFSTATUS'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encounterId=${encId}`);
  }

  // Get Pat AlertsPopup details ,visitDate:Date
  // getAlertsInfo(id: number, visitDate: string): Observable<IAlerts> {
  //   return this.http.get<IAlerts>(
  //     `${configuration.apiUrl + 'Patient/PopupAlerts'}?patientId=${id}&&visitDate=${visitDate}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }

  getAlertsInfo(id: number, visitDate: string): Observable<IAlerts> {
    const alert_PenRequest = {
      patientId: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      visitDate: visitDate
    }
    return this.http.post<IAlerts>(
      `${configuration.apiUrl + 'Patient/PopupAlerts'}`, alert_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getIsORSignedoff(encounterId: string, type: number): Observable<boolean> {
    ;
    return this.http.get<boolean>
      (`${configuration.clinicapiUrl + 'Encounter/ORSignoffStatus'}?encounterId=${encounterId}&&type=${type}`);

  }

  updateSignOffEncounter(encounterDetails: IEncounterData[]): Observable<string> {
    encounterDetails.map(c => {
      c.physicianSignature = null
    });
    const postedData = {
      inputdata: JSON.stringify(encounterDetails)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/SignOffAllNotes'}?facilityId=${sessionStorage.getItem("FacilityId")}`, postedData, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  generateReportsforAllNotes(encounterDetails: IEncounterData[]): Observable<string> {
    const postedData = {
      inputdata: JSON.stringify(encounterDetails)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Document/GenerateReportsForAllNotes'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, postedData, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAllMedicationsWithCodesBySearch(searchstr: string): Observable<IMedicationMasterData[]> {
    const postedData = {
      searchstr: searchstr,
      userid: 'admin',
      medcode: '',
      ttycode: ''
    }
    return this.http.post<IMedicationMasterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsWithCodes'}`, postedData);
    // return this.http.get<IMedicationMasterData[]>(
    //   `${configuration.clinicapiUrl + 'Encounter/MedicationsWithCodes'}?searchstr=${searchstr}&&userid=admin&&medcode=&&ttycode=`);
  }

  getAllSurescriptResponse(facilityId: number): Observable<string> {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'SureScripts/PharmacyResponses'}?facilityId=${sessionStorage.getItem("FacilityId")}&&locId=${Number(sessionStorage.getItem("LocationId"))}`);
  }

  updateReceivedToUser(selectUser: string, roleId: string, receverId: number): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/DashboardRXRecieverUser'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&selectUser=${encodeURIComponent(selectUser).toString()}&&receverId=${receverId}&&roleId=${roleId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get Locations By User
  getLocationsByUser(): Observable<ILocationDetails[]> {
    return this.http.get<ILocationDetails[]>(`${configuration.apiUrl + 'Admin/GetLocationsByUser'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  //**Update selected locationId by User */
  updateLocationByUser(locationId: number): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Admin/UpdateLocationByUser'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locationId=${locationId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //**get locations by Login User */
  getLocationsByLoginUser(): Observable<any> {
    return this.http.get<any>(`${configuration.apiUrl + 'Admin/GetLocationsloginUsers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //**get Feature Appointments */
  getFeatureAppointmentsCount(encounterId: string, patientId: number): Observable<number> {
    return this.http.get<number>(`${configuration.clinicapiUrl + 'Encounter/GetFutureAppointmentsCount'}?encounterId=${encounterId}&&locationId=${Number(sessionStorage.getItem("LocationId"))}&&patientId=${patientId}`);
  }
  getAllFutureComments(facilityId: number): Observable<IAppointmentData[]> {
    return this.http.get<IAppointmentData[]>(
      `${configuration.apiUrl + 'Scheduler/FutureAppCommentS'}?facility=${facilityId}`);
  }

  //**Insert and Update Future Comments */
  InsertFutureAppointmentComments(appointmentId: string, comments: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/FutureAppointmentComments'}?appointmentId=${appointmentId}&&comments=${comments}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //**Get Future Comments */
  GetFutureAppointmentComments(appointmentId: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Scheduler/FutureAppointmentComments'}?appointmentId=${appointmentId}`);
  }

  //***** getOuter Menulist*/
  getOuterMenuList(): Observable<OuterMenu[]> {
    let type = 'User'
    if (sessionStorage.getItem("EmergencyAccessEnabled") && sessionStorage.getItem("EnableEmergencyAccess"))
      type = 'Emergencyuser'

    return this.http.get<OuterMenu[]>(`${configuration.apiUrl + 'Activation/GetOuterMenuList'}?type=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getFacilityDetailsById(facilityid: number, userid: string): any {
    return this.http.get<any>(
      `${configuration.apiUrl + 'Activation/FacilityDetail'}?facilityId=${facilityid}&&userid=${encodeURIComponent(userid).toString()}`);
  }

  //**Insert Security Question  */
  InsertSecurityQuestion(securirtQuestion: string, attributeType: string, attributeDesc: string, createdBy: string): Observable<string> {
    const posteddata = {
      securityQuestion: securirtQuestion,
      attributeType: attributeType,
      attributeDesc: attributeDesc,
      createdBy: createdBy,
      facilityId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/InsertSecurirtyQuestion'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getlocationData(encounterId: string): Observable<LocationHeader> {
    return this.http.get<LocationHeader>(`${configuration.clinicapiUrl + 'Master/LocationHeader'}?encId=${encounterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getServicebyEncounterId(encId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetLocationByEncId'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  // getSecurityQuestionById(id): Observable<IAttributes[]> {
  //   return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/SecurityQuestionByType '}?attributeid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  // }
  getSecurityQuestionById(id): Observable<IAttributes[]> {
    const posteddata = {
      attributeid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IAttributes[]>(`${configuration.apiUrl + 'Master/SecurityQuestionByType'}`, posteddata);
  }

  // Get attributes by attribute type id
  getAllfieldAttributesDOCLIB(TargetLocID: number): Observable<IdoclibFields[]> {
    return this.http.get<IdoclibFields[]>(`${configuration.apiUrl + 'Master/DoclibFieldAttributes'}?TargetLocID=${TargetLocID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllTargetDOCLIB(TargetLocID: number = 0): Observable<IdoclibFields[]> {
    return this.http.get<IdoclibFields[]>(`${configuration.apiUrl + 'Master/DoclibTargetLocations'}?TargetLocID=${TargetLocID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getAllUsersByRoleWithoutLocation(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/AllProvidersByRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }

  getbookAppointmentDetails(Linkid: number): Observable<IMessageInbox> {
    return this.http.get<IMessageInbox>(
      `${configuration.clinicapiUrl + 'Encounter/GetPPbookAppointment'}?Linkid=${Linkid}`);
  }

  OnCancelBooking(LinkId: number, status: string, comments: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateCancelledPPBookAppointment'}?LinkId=${LinkId}&&status=${status}&&user=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&comments=${comments}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getAllUsersByLoc(role: string, CLocId: number): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/ByRole'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${CLocId}`);
  }
  // Get All Clinic Staff by Selected Multi Locations
  getAllUsersBySelectedMultiLocations(locationid: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/AllClinicStaffBySelectedLocation'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&active=${Defaults.active}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${locationid}`);
  }

  // Get city and state details by zipcode for Auto complete dropdown
  getZipCodeDetailsAutoComplete(zipcode: number): Observable<ICityDetails[]> {
    return this.http.get<ICityDetails[]>(
      `${configuration.apiUrl + 'Master/ZipCode'}?zipcode=${zipcode}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //** Viewing the Help Document based on the availability of the Session */
  GetLoginSessionByLoginUser(loginSessionObject): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'InternalChatApplication/GetLoginSessionByLoginUser'}`, loginSessionObject, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //for retrieving Direct messages
  getAllDMResponse(facilityId: number): Observable<string> {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'SureScripts/DMResponses'}?facilityId=${sessionStorage.getItem("FacilityId")}&&locId=${Number(sessionStorage.getItem("LocationId"))}`);
  }
  fnGetAppointmentDetailsByPatientId(patientId: string, fromDate: string, todate: string): Observable<any> {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'Encounter/GetAppointmentDetailsByPatientId'}?patientId=${patientId}&&FromDate=${fromDate}&&toDate=${todate}`);
  }

  getGranualracecodes(name: string): Observable<IRace[]> {
    return this.http.get<IRace[]>(`${configuration.apiUrl + 'Master/RaceCodes'}?name=${name}`);
  }

  selectCopyPrintAuditLog(AuditLogInfo: AuditLog): Observable<string> {
    AuditLogInfo.EncounterId = sessionStorage.getItem("encounterid");
    AuditLogInfo.LocationId = sessionStorage.getItem("LocationId");
    AuditLogInfo.UserID = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    AuditLogInfo.PatientID = Number(sessionStorage.getItem("patientId"));
    if (!AuditLogInfo.ChangedValues)
      AuditLogInfo.ChangedValues = '';
    AuditLogInfo.ActionType = 'SELECT';
    AuditLogInfo.PreviousValues = '';
    AuditLogInfo.TransactionStatus = 'Success';
    AuditLogInfo.Type = null;
    const posteddata = {
      inputdata: JSON.stringify(AuditLogInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/selectCopyPrintAuditLog'}`, posteddata, {
    });
  }
  //** Ammendment  */
  UpdateAmmendmentStatus(LinkId: string, status: string, comments: string, statusType: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateAmmendmentStatus'}?LinkId=${LinkId}&&status=${status}&&user=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&comments=${comments}&&statusType=${statusType}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAmmendmentNoteInformation(encounterId: string, type: string, requestId: string): Observable<IAmmendment> {
    return this.http.get<IAmmendment>(
      `${configuration.clinicapiUrl + 'Encounter/AmmendmentInformation'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&requestId=${requestId}&&encounterId=${encounterId}&&type=${type}`);
  }

  // Get all oncc configuratios
  getAllONCCConfiguration(): Observable<ONCCConfiguration[]> {
    return this.http.get<ONCCConfiguration[]>(
      `${configuration.clinicapiUrl + 'Master/ONCCConfig'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Delete oncc configuratios info
  DeleteONCCConfiguration(configId: number): Observable<string> {
    return this.http.delete<string>(
      `${configuration.clinicapiUrl + 'Master/ONCCConfig'}?configId=${configId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Delete oncc configuratios info
  SaveOrUpdateONCCConfiguration(configObj: any): Observable<string> {
    const postedData = {
      inputdata: JSON.stringify(configObj)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/ONCCConfig'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getONCCMeasuresName
  getONCCMeasuresNameService(measureId: number = 0, MeasureName: string = "null"): Observable<ONCCMasterMeasures[]> {
    return this.http.get<ONCCMasterMeasures[]>(
      `${configuration.apiUrl + 'Master/ONCCMeasuresNameService'}?MeassureId=${measureId}&&MeasureName=${MeasureName}`);
  }

  GetAutoMeasureCalculation(measureName: string, reportYear: string, provIds: string, LocIds: string): Observable<AutoMeasureReportConfig[]> {
    const postedDate = {
      MeasureName: measureName,
      Year: reportYear,
      ProviderIds: provIds,
      LocationsIds: LocIds,
    }
    return this.http.post<AutoMeasureReportConfig[]>(
      `${configuration.apiUrl + 'Document/AutoMeasure'}`, postedDate);
  }

  // Get all payment source
  getInsPaymentSource(): Observable<IPaymentSource[]> {
    return this.http.get<IPaymentSource[]>(`${configuration.apiUrl + 'Master/InsPaymentSource'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  GetMeasureNumDenum(measureName: string, reportYear: string, provIds: string, LocIds: string, type: string, patientId: number): Observable<MeasureNumDenumaretor[]> {
    const postedDate = {
      MeasureName: measureName,
      Year: reportYear,
      ProviderIds: provIds,
      LocationsIds: LocIds,
      Type: type,
      PatientId: patientId
    }
    return this.http.post<MeasureNumDenumaretor[]>(`${configuration.apiUrl + 'Document/MUNumDenumarator'}`, postedDate);
  }

  getUsersMultipleRoles(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(`${configuration.apiUrl + 'Admin/UsersMultipleRoles'}?facility=${sessionStorage.getItem("FacilityId")}`);
  }

  GetSetUserConfiguration(values: string, StorageType: string, RequestType: string): Observable<any> {
    const postedData1 = {
      UserId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      values: values,
      StorageType: StorageType,
      RequestType: RequestType
    }
    const posteddata = {
      inputdata: JSON.stringify(postedData1)
    }
    return this.http.post<any>(`${configuration.apiUrl + 'Admin/UserConfiguration'}`, posteddata);

  }

  getAllUsersWithOutLocation(role: string): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Admin/UsersWithoutLocation'}?roleid=${role}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  GetOldPatientFalg(PatId: number): Observable<boolean> {
    return this.http.get<boolean>
      (`${configuration.clinicapiUrl + 'Patient/OldPatient'}?patId=${PatId}`);

  }

  getPreviousTreatmentPatientInfo(id: number, AppDate: string, AppId: string): Observable<IPatientSearch> {
    return this.http.get<IPatientSearch>(
      `${configuration.apiUrl + 'Patient/GetPreviousTreamentVisitDetailsByPatientId'}?patientid=${id}&&AppDate=${AppDate}&&AppId=${AppId}`);
  }

  getAllMaterPayerTypeDetails(): Observable<MasterPayerTypes[]> {
    return this.http.get<MasterPayerTypes[]>(
      `${configuration.apiUrl + 'Master/PayerTypes'}`);
  }

  SaveOrUpdatePayerClassDetails(payerclassObj: BillingClaimCodesMaster): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(payerclassObj)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/PayerClassInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetAllClaimCodesMastersDetails(pctype): Observable<BillingClaimCodesMaster[]> {
    return this.http.get<BillingClaimCodesMaster[]>(
      `${configuration.apiUrl + 'Master/ClaimCodes'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&pcType=${pctype}`);
  }

  getASCFacilityInfo(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Encounter/ChildFacilities'}?facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  InsertPatientInfoInASCFacility(ascPatRefTrackObj: PatientReferralTracker): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(ascPatRefTrackObj)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Encounter/PatientReferralASC'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
